import { MAIN_CURRENCY, PLATFORM_FEE_CURRENCY } from '@okletsplay/core';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { createSelector } from 'reselect';
import { ExchangeRatesState } from './interfaces';
import { ExchangeRateDto } from 'app/interfaces/dto';

const exchangeRatesState = (state: AppState): ExchangeRatesState =>
  state[EntityStoreName.ExchangeRates];

export const exchangeRatesSelector = {
  /**
   * @deprecated This may be not valid selector considering CurrencyType introduced.
   */
  mainToPlatformFee: createSelector(exchangeRatesState, ({ entities }: ExchangeRatesState) => {
    return entities[PLATFORM_FEE_CURRENCY + MAIN_CURRENCY]?.rate;
  }),
  /**
   * @deprecated This may be not valid selector considering CurrencyType introduced.
   */
  mainToUsd: createSelector(exchangeRatesState, ({ entities }: ExchangeRatesState) => {
    return entities['USD' + MAIN_CURRENCY]?.rate;
  }),
  all: createSelector(
    exchangeRatesState,
    ({ entities }: ExchangeRatesState) => Object.values(entities) as ExchangeRateDto[]
  ),
};
